<template>
  <v-dialog v-model="visible" max-width="800px" persistent>
    <v-card>
      <v-card-title>{{ title }}</v-card-title>
      <v-card-text>
        <template v-if="bossInfo">
          <!-- 玩法說明 -->
          <v-textarea
            v-model="bossInfo.intro"
            label="玩法說明"
            :color="Theme.GREEN"
            rows="3"
            auto-grow
          ></v-textarea>

          <!-- Boss 名稱 -->
          <v-text-field
            v-model="bossInfo.bossName"
            label="Boss 名稱"
            :color="Theme.GREEN"
          ></v-text-field>

          <!-- Boss 對話內容 -->
          <v-text-field
            v-model="bossInfo.tip"
            label="Boss 對話內容"
            :color="Theme.GREEN"
          ></v-text-field>

          <!-- Boss 最大血量 -->
          <v-text-field
            v-model.number="bossInfo.maxHealth"
            type="number"
            label="Boss 最大血量"
            :color="Theme.GREEN"
          ></v-text-field>

          <!-- 背景圖上傳 -->
          <v-layout class="ma-1">
            <v-text-field
              v-model="bossInfo.backgroundURL"
              label="背景圖網址(1920x1080)"
              :color="Theme.GREEN"
            >
            </v-text-field>
            <v-flex
              xs6
              md3
              class="ml-2"
              style="max-width: 98px; position: relative; cursor: pointer"
            >
              <input
                type="file"
                @change="onFileChangeBoss($event, 'backgroundURL')"
                style="position: absolute; inset: 0; z-index: 20; opacity: 0"
              />
              <v-btn type="button" color="primary" style="position: relative"
                >上傳圖片</v-btn
              >
            </v-flex>
          </v-layout>
          <v-layout class="ma-1" v-if="bossInfo.backgroundURL">
            <img style="height: 200px" :src="bossInfo.backgroundURL" />
          </v-layout>

          <!-- Boss圖示上傳 -->
          <v-layout class="ma-1">
            <v-text-field
              v-model="bossInfo.bossImageURL"
              label="Boss 圖示網址(正方形 800px以上)"
              :color="Theme.GREEN"
            >
            </v-text-field>
            <v-flex
              xs6
              md3
              class="ml-2"
              style="max-width: 98px; position: relative; cursor: pointer"
            >
              <input
                type="file"
                @change="onFileChangeBoss($event, 'bossImageURL')"
                style="position: absolute; inset: 0; z-index: 20; opacity: 0"
              />
              <v-btn type="button" color="primary" style="position: relative"
                >上傳圖片</v-btn
              >
            </v-flex>
          </v-layout>
          <v-layout class="ma-1" v-if="bossInfo.bossImageURL">
            <img style="height: 200px" :src="bossInfo.bossImageURL" />
          </v-layout>

          <v-divider class="my-4"></v-divider>

          <!-- 獎品名稱 -->
          <v-text-field
            v-model="bossInfo.prizeName"
            label="獎品名稱"
            :color="Theme.GREEN"
          ></v-text-field>

          <!-- 獎品圖示上傳 -->
          <v-layout class="ma-1">
            <v-text-field
              v-model="bossInfo.prizeImageURL"
              label="獎品圖示網址(正方形 800px以上)"
              :color="Theme.GREEN"
            >
            </v-text-field>
            <v-flex
              xs6
              md3
              class="ml-2"
              style="max-width: 98px; position: relative; cursor: pointer"
            >
              <input
                type="file"
                @change="onFileChangeBoss($event, 'prizeImageURL')"
                style="position: absolute; inset: 0; z-index: 20; opacity: 0"
              />
              <v-btn type="button" color="primary" style="position: relative"
                >上傳圖片</v-btn
              >
            </v-flex>
          </v-layout>
          <v-layout class="ma-1" v-if="bossInfo.prizeImageURL">
            <img style="height: 200px" :src="bossInfo.prizeImageURL" />
          </v-layout>

          <!-- 獎品數量 -->
          <v-text-field
            v-model.number="bossInfo.quantity"
            type="number"
            label="獎品數量"
            :color="Theme.GREEN"
          ></v-text-field>

          <!-- 獎品回收價 -->
          <v-text-field
            v-model.number="bossInfo.recyclePrice"
            type="number"
            label="獎品回收價"
            :color="Theme.GREEN"
          ></v-text-field>

          <!-- 額外紅利 -->
          <v-text-field
            v-model.number="bossInfo.bonus"
            type="number"
            label="額外紅利"
            :color="Theme.GREEN"
          ></v-text-field>

          <!-- 啟用狀態 -->
          <v-switch
            v-model="bossInfo.enable"
            label="啟用"
            :color="Theme.GREEN"
          ></v-switch>
        </template>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey darken-1" text @click="cancel">取消</v-btn>
        <v-btn color="primary" text @click="confirm" :loading="saveLoading"
          >確定</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import common from "@/mixins/common";
import { mapActions } from "vuex";

export default {
  name: "boss-detail",
  mixins: [common],
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    itemDetail: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      saveLoading: false,
      bossInfo: null,
    };
  },
  watch: {
    itemDetail: {
      handler(val) {
        if (val) {
          this.bossInfo = JSON.parse(JSON.stringify(val));
        }
      },
      immediate: true,
    },
  },
  methods: {
    ...mapActions(["uploadFileV2", "saveBossInfo"]),

    async onFileChangeBoss(e, type) {
      const file = e.target.files[0];
      if (file) {
        const formData = new FormData();
        formData.append("image", file);

        try {
          this.saveLoading = true;
          const res = await this.uploadFileV2(formData);

          const result = res.data;
          console.log(`uploadImage == ${JSON.stringify(result)}`);
          if (result && result.statusCode === 0) {
            this.showMessageDialog("提示", result.message);
            this.bossInfo[type] = result.data.url;
          } else {
            this.showMessageDialog(
              "提示",
              result.message ? result.message : "上傳失敗"
            );
          }
        } catch (e) {
          console.log(`uploadImage error `, e);
          this.showMessageDialog("提示", "發生錯誤！");
        } finally {
          this.saveLoading = false;
        }
      }
    },

    async confirm() {
      try {
        this.saveLoading = true;
        const bossData = {
          ...this.bossInfo,
          maxHealth: Number(this.bossInfo.maxHealth) || 0,
          quantity: Number(this.bossInfo.quantity) || 0,
          recyclePrice: Number(this.bossInfo.recyclePrice) || 0,
          bonus: Number(this.bossInfo.bonus) || 0,
          bossId: this.bossInfo.bossId || "",
          productId: "world"
        };

        const res = await this.saveBossInfo(bossData);
        if (res.data.statusCode === 0) {
          this.showMessageDialog("提示", "儲存成功");
          this.$emit("confirmEvent");
        } else {
          this.showMessageDialog("提示", "儲存失敗");
        }
      } catch (e) {
        this.showMessageDialog("提示", "儲存失敗");
      } finally {
        this.saveLoading = false;
      }
    },

    cancel() {
      this.$emit("cancelEvent");
    },

    showMessageDialog(title, content) {
      this.showAlert({
        title: title,
        content: content,
        showCancel: false,
        confirmEvent: async () => {
          this.hideAlert();
        },
      });
    },
  },
};
</script>
